import { Format, FormattedText, FormattedTextResult, restoreSupportedHTMLEntities, textFormatter } from "loom-text-formatting";
import * as React from "react";

/**
 * @deprecated This will be removed. Users of this component should instead consume it from oui-savant, https://objectstorage.us-phoenix-1.oraclecloud.com/n/uxdev/b/oui-savant-showcase/o/latest/index.html#/components/formatted-string
 * Takes in a FormattedTextResult and returns an array of JSX.Elements containing tags to be
 * rendered
 *
 * @param nestedResultText FormattedTextResult used to parse through and convert each element to an
 * array of JSX.Elements
 * @returns React.ReactNode to be rendered
 */
function convertToJSX(resultText: FormattedTextResult, onClick?: (() => void) | undefined): React.ReactNode {
  const elements: React.ReactNode[] = [];
  resultText.forEach((element: string | FormattedText, index: number) => {
    if (typeof element === "string") {
      const parsedElement = restoreSupportedHTMLEntities(element)
      elements.push(parsedElement);
    } else if (element.content) {
      const content: React.ReactNode = convertToJSX(element.content);
      switch (element.format) {
        case Format.Emphasized: {
          elements.push(<em key={index}>{content}</em>);
          break;
        }
        case Format.Link: {
          elements.push(
            <a key={index} onClick={onClick} {...element.properties}>
              {content}
            </a>,
          );
          break;
        }
        case Format.Strong: {
          elements.push(<strong key={index}>{content}</strong>);
          break;
        }
      }
    }
  });
  return elements;
}

interface Props {
  inputText: string;
  onClick?(): void;
}

const FormattedString: React.SFC<Props> = (props: Props) => {
  const text: string = props.inputText;
  // Get the formatted text from the textFormatter and then convert to JSX
  const formattedText: FormattedTextResult = textFormatter(text);

  // Convert the FormattedTextResult react elements
  return <>{convertToJSX(formattedText, props.onClick)}</>;
};

export default FormattedString;
